import { Button, Drawer, Dropdown, Tooltip } from "antd";
import React, { useCallback, useEffect, useMemo } from "react";
import styles from "./detail.module.less";
import Empty from "@/components/Supervise/components/empty";
import { Avatar } from "@/baseComponents/Avatar";
import { convertEmployeeToString, getUnitTitleInfo } from '@/utils/chat/message';
import { getHeadImgThumbUrl } from "@/utils/chat/index";
import { formate } from "@/utils/date";
import Bus from "@/utils/bus";
import { connect } from "dvajs";
import ChatState from "@/types/chat/State";
import { QuickReplyStatus } from "@jd/jdee.im.sdk/lib/es/protocol/message/Text";
import { tagsNode } from "@jd/focus-desktop-comps/lib/es/UserCard/common";

function QuickReplyDetail(props: any) {
  const {
    detailVisible,
    handleClose,
    replyUsers,
    handleRevokeReply,
    changeQuickReplyStatus,
    openUserCard,
    isOwner,
    hasOpen,
    unOpen,
    hasReply,
    overtime,
    userNum = 0,
    unitNum = 0
  } = props;
  const visibleChange = (e: MouseEvent) => {
    if (detailVisible) {
      Bus.emit("message-item-chatitem", true);
    }
  };
  useEffect(() => {
    document.addEventListener("contextmenu", visibleChange);
    return () => {
      document.removeEventListener("contextmenu", visibleChange);
    };
  });

  const itemsComp = useCallback(
    (u: any) => {
      return (
        <div
          className={styles["item"]}
          key={convertEmployeeToString(u)}
          onClick={() => openUserCard(u)}
        >
          <Avatar
            className={styles["avatar"]}
            src={getHeadImgThumbUrl(u.avatar, 150, 150)}
            name={u.name}
          />
          <div className={styles["info"]}>
            <div className={styles["name-wrap"]}>
              <span className={`${styles["name"]} ellipsis`}>{u.name}</span>
              {u.labelInfoList ? tagsNode(u.labelInfoList) : null}
              <span className={styles["time"]}>{formate(u.timeStamp, true)}</span>
            </div>
            <span className={`${styles["unit"]} ellipsis`}>
              {getUnitTitleInfo(u.unitName, u.titleName)}
            </span>
          </div>
        </div>
      );
    },
    [openUserCard]
  );

  // footer
  const DrawerFooter = useMemo(() => {
    if (overtime) {
      return null;
    }
    if (isOwner) {
      const status = hasOpen ? QuickReplyStatus.CLOSE : QuickReplyStatus.OPEN;
      return (
        <Button
          className={styles["drawer-footer-btn"]}
          onClick={() => changeQuickReplyStatus(status)}
        >
          {`${hasOpen ? "关闭回复" : `${!unOpen ? "重新" : ""}发起回复`}`}
        </Button>
      );
    } else if (hasReply && hasOpen) {
      return (
        <Button
          className={`${styles["drawer-footer-btn"]} ${styles["danger"]}`}
          onClick={handleRevokeReply}
        >
          撤回回复
        </Button>
      );
    }
    return null;
  }, [overtime, isOwner, hasReply, hasOpen, unOpen, changeQuickReplyStatus, handleRevokeReply]);

  return (
    <Drawer
      title={
        <div className={styles["drawer-title"]}>
          <span className={styles["drawer-title-name"]}>回复详情</span>
        </div>
      }
      className={styles["reply-detail-drawer"]}
      placement="right"
      width={310}
      onClose={handleClose}
      visible={detailVisible}
      destroyOnClose={true}
      maskClosable={true}
      footer={DrawerFooter}
    >
      {!replyUsers?.length ? (
        <Empty text="暂无回复" />
      ) : (
        <>
          <div className={styles["info-wrap"]}>
            <span className={styles["item"]}>
              已回复：<span className={styles["num"]}>{userNum}</span>人
            </span>
            <span className={styles["item"]}>
              已回复单位：<span className={styles["num"]}>{unitNum}</span>个
            </span>
          </div>
          <div className={styles["user-list"]}>
            {replyUsers.map((u: any) => {
              return itemsComp(u);
            })}
          </div>
        </>
      )}
    </Drawer>
  );
}

function mapStateToProps({ chat }: { chat: ChatState }) {
  const { currentEmployee } = chat;
  return {
    currentEmployee
  };
}

function mapDispatchToProps(dispatch: any) {
  return {};
}
export default connect(mapStateToProps, mapDispatchToProps)(QuickReplyDetail);
